import { Injectable } from '@angular/core';

/*
  Generated class for the DataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class DataProvider
{

   // selection
   public activeTab = 1;
   public currentStep = 0;
   public isPhy = true;
   public selectedTicket : any = {};
   public selectedPatient = {};
   public selectedMedicals = {};
   public selectedTicketStatus : string = "";

   public consRemark = '';
   // public chosenSymptoms = [];
   // public chosenSymptomsRemarks = [];
   public dxIdx = -1;
   public dxCustom = '';
   // public chosenDisps = [];
   public dispBoardActive = [];

   // account
   public accountInfo = {};
   public token = '';

   // queues
   public standbys = [];
   public pendings = [];
   public actives = [];
   public dones = [];
   public needs = [];
   public dispensings = [];
   public ends = [];
   public bookings = {};
   public checkins = {};

   // consultations
   public symptoms = [];
   public diagnoses = [];
   public dispSingleCats = [];
   public dispSingles = [];
   public dispGrps = [];
   public dispPills = [];
   public dispExternals = [];
   public dispInternals = [];
   public acuSingles = [];
   public acuGrps = [];
   public usages = [];


   /** ----- Constructor ----- **/

   constructor() {}


   /** ----- Public Methods ----- **/

   getSymptomById( inId )
   {

      for ( let i = 0; i < this.symptoms.length; i++ )
      {

         if ( this.symptoms[ i ][ 'id' ] == inId )
         {

            return this.symptoms[ i ];

         }

      }


      return {};

   }


   getDispGrpById( inId )
   {

      for ( let i = 0; i < this.dispGrps.length; i++ )
      {
         if ( this.dispGrps[ i ][ 'grp_id' ] == inId )
         {
            return this.dispGrps[ i ];
         }
      }
      return '';

   }


   getDispSingleById( inId )
   {
      for ( let i = 0; i < this.dispSingles.length; i++ )
      {
         if ( this.dispSingles[ i ][ 'id' ] == inId )
         {
            return this.dispSingles[ i ];
         }
      }
      return '';

   }


   getDispPillById( inId )
   {

      for ( let i = 0; i < this.dispPills.length; i++ )
      {
         if ( this.dispPills[ i ][ 'grp_id' ] == inId )
         {
            return this.dispPills[ i ];
         }
      }      return '';

   }


   getAcuGrpById( inId )
   {

      for ( let i = 0; i < this.acuGrps.length; i++ )
      {
         if ( this.acuGrps[ i ][ 'grp_id' ] == inId )
         {
            return this.acuGrps[ i ];
         }
      }
      return '';

   }

}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts